<template>
    <div class="project-tab-wampper">
        <ul class="tab-tilte">
            <li class="tab-list font-FFFFFF-50 font-5-family"
                :class="{active:index===changeIndex}"
                v-for="(item,index) in tabList"
                :key="index"
                @click="toggleTab(index)">{{item}}</li>
        </ul>
        <div v-for='(item,numindex) in tabList' :key='numindex'>
            <div v-if="changeIndex==numindex">
                <superviseList :changeIndex="numindex" :changeData="chartData[numindex]"></superviseList>
            </div>
        </div>

    </div>
</template>
<script>
import superviseList from './superviseList'
export default {
    name: 'projectTab',
    components: {
        superviseList
    },
    props : {},
    data() {
        return{
            progressActive: 'first',
            changeIndex: 0,
            active: 0,
            chartData: [],
            tabList: [],
            tabtimer: null
        }
    },
    mounted(){
        this.getTabAxios();
        this.tabtimer = setInterval(() => {
            this.getTabAxios()
        }, 5000)
    },
    methods:{
        handleClickProgressTab(tab, event) {
            console.log(tab, event);
        },
        toggleTab(index) {
            this.active = index
            this.changeIndex = index
        },
        getTabAxios(){
            let _this = this;
            let url = `${window.pubilc_config.webserverurl}/api/Daxing/Daxing/`;
            _this.$axios
                .get(url+'Getimage')
                .then(res=>{
                    if (res.status == 200) {
                        let beforeData = res.data;

                        // 返回的数据为一维数组，先按照image_type分类 得到arrayTwo为分类后的二维数组
                        // 转换后的二维数组
                        let xData = []
                        let arrayTwo = Object.values(beforeData.reduce((res, item) => {
                            // res[item.image_type] ? res[item.image_type].push(item) : res[item.image_type] = [item];
                            if(res[item.image_type]) {
                                res[item.image_type].push(item)
                            } else {
                                res[item.image_type] = [item]
                                xData.push(item.image_type)
                            }
                            return res;
                        }, {}));
                        // console.log(arrayTwo,'==')
                        if(_this.tabList.length === 0) {
                            _this.tabList = xData
                        }
                        let series = []
                        for(let i =0; i < arrayTwo.length; i++){
                            let xData = []
                            for(let a of arrayTwo[i]) {
                                xData.push(a.image_children)
                            }
                            let seriesdata = []
                            let arr = ['image_complete','image_lastweek','image_accumulative']
                            for(let j =0; j < arr.length; j++){
                              seriesdata[j] = _this.getarr(arrayTwo[i],arr[j])
                            }
                            series.push({xData: xData, data: seriesdata})
                        }
                        _this.chartData = series

                    }
                }).catch(err=>{
                    console.log(err,'===api/Daxing/Daxing/Getimage')
                })
        },
        getarr(arr,params){
            let _a = []
            arr.forEach(item=>{
                _a.push(item[params]);
            })
            return _a
        },	
    },
    destroyed () {
        clearTimeout(this.tabtimer)
    }
}
</script>
<style lang="scss" scoped>
.project-tab-wampper{
    .tab-tilte{
        display: flex;
        flex-wrap: wrap;
        .tab-list{
            min-width: 25%;
            background: url('../../assets/images/progress_tab.png') no-repeat;
            line-height: 30px;
            background-size: 100% 100%;
            text-align: center;
            cursor: pointer;
            margin-bottom: 4px;
            padding: 0 6px;
            // overflow: hidden;
            // white-space: nowrap;
            // text-overflow: ellipsis;
        }
        .active{
            color: #26ABFF;
        }  
        .tab-list:hover{
            color: #26ABFF;
        }
    }
}
</style>